// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.flexs{\n    display:-webkit-box;\n    display:-ms-flexbox;\n    display:flex;\n}\n.pages{\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n}\n.pages-scrolltop{\n    position:fixed;\n    top:0;\n    padding: 20px 0;\n    background: #fff;\n    z-index: 999;\n    width: calc(100% - 310px);\n}\n", ""]);
// Exports
module.exports = exports;
